import axios from "axios";
import {API_HEADER} from "@/common/utils/constants";

const state = {
	user: {
		id: null,
		fullName: null,
		gopUserCountry: {},
		jwt: null,
		email: null,
		isSso: false,
		drafts: [],
		permissions: []
	}
};

const getters = {
	getUser: (state) => state.user
};

const actions = {
	setNewCountry({commit}, country) {
		commit('setNewCountry', country);
	},
	setUserJwtToAxiosConfig({commit}, {jwt, isSso}) {
		commit('setUserJwtToAxiosConfig', {jwt, isSso});
	},
	signout({commit}) {
		commit('setUserCleanLogin');
	},
	signIn({commit}, payload) {
		commit('setUserJwtToAxiosConfig', payload.data);
		commit('setUserLogin', payload);
	},
	setUserData({commit}, payload) {
		commit('setUserLogin', payload);
	}
};

const mutations = {
	setNewCountry(state, country) {
		state.user.gopUserCountry = country
	},
	setUserLogin: (state, payload) => {
		Object.keys(payload.data).forEach(field => {
			if (field) {
				state.user[field] = payload.data[field]
			}
		})
	},
	setUserCleanLogin: (state) => {
		axios.defaults.headers.common[API_HEADER.authorization] = null;
		state.user = {
			id: null,
			fullName: null,
			jwt: null,
			email: null,
			isSso: false,
			drafts: [],
			permissions: []
		}
	},
	setUserJwtToAxiosConfig(state, payload) {
		localStorage.setItem(API_HEADER.jwt, payload.jwt);
		localStorage.setItem('isSso', payload.isSso);
		axios.defaults.headers.common[API_HEADER.authorization] = payload.jwt;
	}
};
export default {state, getters, actions, mutations};
